"use strict";
/*
 * Created on 29/01/2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 *
 * @author JMr
 */


var LocalisationRowConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(LocalisationRowConverter, _DataObjectConverter_);

  function LocalisationRowConverter() {
    _classCallCheck(this, LocalisationRowConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(LocalisationRowConverter).apply(this, arguments));
  }

  return LocalisationRowConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.LocalisationRowConverter = LocalisationRowConverter;